import React, { useEffect, useState } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { ImagemService } from '../../../../../platform/viewer/src/service/ImagemService';

function CheckImagemChave(props) {

  const {
    SeriesInstanceUID,
    StudyInstanceUID,
    SOPInstanceUID
  } = props.stateObjImageKey;

  useEffect(() => {
    if (SOPInstanceUID) {
      getImageKey();
    }
  }, [SOPInstanceUID])

  const [checked, setChecked] = useState(false);

  function onChangeChecked(e) {
    fncSetImageKey(e.checked);
    setChecked(e.checked);
  }

  function getImageKey() {
    try {
      const checked = window.memoImagesKey.filter(imagem => imagem === SOPInstanceUID).length > 0;
      setChecked(checked);
    } catch (error) {
      console.log(error);
    }
  }

  function fncSetImageKey(checked) {

    const putImageKey = value => {
      const imageService = new ImagemService();
      return imageService.putImageKey(value, StudyInstanceUID, SeriesInstanceUID, SOPInstanceUID);
    }

    if (checked) {
      putImageKey('1')
        .then(resp => {
          if (resp.status === 200) {
            if (window.memoImagesKey)
              window.memoImagesKey.push(SOPInstanceUID);
            return;
          }
          alert('Falha ao definir imagem chave');
        })
        .catch(error => {
          console.log(error);
        });
      return;
    }

    if (checked === false) {
      putImageKey('0')
        .then(resp => {
          if (resp.status === 200) {
            const memoImagemChave = window.memoImagesKey.filter(imagem => imagem !== SOPInstanceUID);
            window.memoImagesKey = memoImagemChave;
            return;
          }
          alert('Falha ao definir imagem chave');
        })
        .catch(error => {
          console.log(error);
        })
    }
  }

  return (
    <div
      style={{
        color: 'white',
        textAlign: 'right',
        zIndex: '999999',
        top: '0',
        right: '0',
        background: 'rgb(7 20 38)',
        borderBottomLeftRadius: '18px',
        marginLeft: '10px'
      }}>
      <div style={{ display: 'flex', gap: '5px', padding: '5px 5px 7px 12px' }}>
        <i className="pi pi-key" style={{ fontSize: 'small', marginTop: '3px' }}></i>
        <Checkbox
          key={`comp-${SOPInstanceUID}`}
          id={`comp-${SOPInstanceUID}`}
          checked={checked}
          onChange={e => onChangeChecked(e)}
        />
      </div>
    </div>
  );
}

export default CheckImagemChave;
